export function forms() {

  $(document).ready(function () {

    let $diffBilling = $('[name="differentBillingAddress"]');
    if ($diffBilling.length > 0) {

      let $newServiceAddress = $('[name="newServiceAddress"]');
      let $newServiceCity = $('[name="newServiceCity"]');
      let $newServiceState = $('[name="newServiceState"]');
      let $newServiceZipCode = $('[name="newServiceZipCode"]');

      let $billingAddress = $('[name="billingAddress"]');
      let $billingCity = $('[name="billingCity"]');
      let $billingState = $('[name="billingState"]');
      let $billingZipCode = $('[name="billingZipCode"]');

      function copyServiceAddressToBilling() {
        $billingAddress.val($newServiceAddress.val());
        $billingCity.val($newServiceCity.val());
        $billingState.val($newServiceState.val());
        $billingZipCode.val($newServiceZipCode.val());
      }

      function clearBillingAddress() {
        $billingAddress.val('');
        $billingCity.val('');
        $billingState.val('');
        $billingZipCode.val('');
      }

      let initVal = $diffBilling.filter(':checked').val();
      if (initVal == "No") {
        copyServiceAddressToBilling();
      } 

      $diffBilling.on('change', function(e){
        if (this.value == "No") {
          copyServiceAddressToBilling();
        } else {
          clearBillingAddress();
        }
      });

      // event listeners
      $newServiceAddress.on('keyup', function(e){
        if ($diffBilling.filter(':checked').val() == "No") {
          copyServiceAddressToBilling();
        }
      });
      $newServiceCity.on('keyup', function(e){
        if ($diffBilling.filter(':checked').val() == "No") {
          copyServiceAddressToBilling();
        }
      });
      $newServiceState.on('change', function(e){
        if ($diffBilling.filter(':checked').val() == "No") {
          copyServiceAddressToBilling();
        }
      });
      $newServiceZipCode.on('keyup', function(e){
        if ($diffBilling.filter(':checked').val() == "No") {
          copyServiceAddressToBilling();
        }
      });

    }

  });

}


// WEBPACK FOOTER //
// ./resources/js/utils/forms.js